<template>
  <div class="flex flex-wrap col-12 p1 border">
    <div class="flex flex-wrap col-12 pointer" @click="toggle()">
      <div class="flex col-2 justify-start items-center"><span class="flex justify-center items-center" style="height:50px;width:50px">+</span></div>
      <div class="flex col-8 items-center bold">Nouveau participant</div>
      <div class="flex col-2 justify-end items-center pr1">
        <i
          class="icon flex h1 dark-grey"
          :class="[{
            'icon-chevron-up': !collapsed,
            'icon-chevron-down': collapsed,
          }]"
        ></i>
      </div>
    </div>
    <NewTDAAddParticipantForm v-if="!collapsed" @close="toggle()" />
  </div>
</template>

<script>
import NewTDAAddParticipantForm from '@/components/participants/NewTDAAddParticipantForm.vue';

export default {
  components: { NewTDAAddParticipantForm },
  data () {
    return { collapsed: true };
  },
  methods: {
    toggle () {
      this.collapsed = !this.collapsed;
    }
  }
};
</script>
